module.exports = __webpack_public_path__ + "img/u2998.8fc60bf8.png";